import { createContext, useContext } from 'react';

// Panel Group Context
export const PanelGroupContext = /*#__PURE__*/createContext(null);
export const usePanelGroup = () => useContext(PanelGroupContext);

// Panel Context
export const PanelContext = /*#__PURE__*/createContext(null);
export const usePanel = () => useContext(PanelContext);